import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Components from './components/components';
import HotTopicDetail from '../components/hotTopicDetail';

import './socialMedia.less';
import './socialMedia-en.less';
import './socialMedia.theme.less';

export interface ISocialMediaProps {
  topicName: string;
  topicSettings: any[];
}

export function SocialMedia(props: ISocialMediaProps) {
  return (
    <Routes key={props.topicName}>
      <Route
        path="/"
        element={
          <HotTopicDetail
            settings={props.topicSettings}
            components={Components}
          />
        }
      />
    </Routes>
  );
}
